const e = {
  1: "1em",
  // 100%
  2: "1.1em",
  // 110%
  3: "1.15em",
  // 115%
  4: "1.2em",
  // 120%
  5: "1.25em",
  // 125%
  6: "1.5em"
  // 150%
};
export {
  e as default
};
